<template>
  <modal
      :canBeClosedByUser="canBeClosedByUser"
      @close="$emit('close')"
      class="custom-popup-modal statistic-popup"
      v-bind:class="{'loading' : loading}"
  >
    <template slot="header">
      <template v-if="!loading">
        <div
            v-if="titleText !== ''"
            v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
          <div class="admin-edit" @click="editTranslate([titleText,])"></div>
          {{ $t(`${titleText}.localization_value.value`) }}
        </div>
        <div
            v-else
            v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
          <div class="admin-edit" @click="editTranslate(['dashboard_orderSummary',])"></div>
          {{ $t('dashboard_orderSummary.localization_value.value') }}
        </div>
      </template>

    </template>
    <template slot="body">

      <div id="dropin-container"></div>

      <form v-show="!loading">

        <template v-if="consolidationType">
          <template
              v-if="consolidationData && _.has(consolidationData, 'totals') && consolidationData.totals.orders.length > 0">
            <div class="statistic-popup__price mb-2"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}"
                 v-for="(order, index) in consolidationData.totals.orders"
                 :key="index"
            >
              <div class="admin-edit" @click="editTranslate(['consolidation_OrdersAmount',])"></div>
              <b>{{ $t('consolidation_OrdersAmount.localization_value.value') }} : #{{order.id}} : ${{ order.delivery_cost }}</b>
            </div>
          </template>

          <div class="statistic-popup__price mb-2"
               v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}"
               v-if="consolidationData && _.has(consolidationData, 'totals')"
          >
            <div class="admin-edit" @click="editTranslate(['consolidation_consolidationShipment',])"></div>
            <b>{{ $t('consolidation_consolidationShipment.localization_value.value') }} : #{{consolidationData.totals.consolidation.id}} : ${{ consolidationData.totals.consolidation.order_amount }}</b>
          </div>

<!--          <div class="statistic-popup__price mb-2"-->
<!--               v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}"-->
<!--               v-if="consolidationData && _.has(consolidationData, 'totals')"-->
<!--          >-->
<!--            <div class="admin-edit" @click="editTranslate(['consolidation_consolidationShipment',])"></div>-->
<!--            <b>{{ $t('consolidations_vatCost.localization_value.value') }} : #{{consolidationData.totals.consolidation.id}} : ${{ consolidationData.totals.consolidation.vat_amount }}</b>-->
<!--          </div>-->

          <div class="statistic-popup__price mb-2"
               v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}"
               v-if="consolidationData && _.has(consolidationData, 'payment_system_commission')"
          >
            <div class="admin-edit" @click="editTranslate(['mypayments_braintreeFee',])"></div>
            <b>{{ $t('mypayments_braintreeFee.localization_value.value') }}: ${{ consolidationData.payment_system_commission }}</b>
          </div>

          <div class="statistic-popup__price mb-2"
               v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}"
               v-if="consolidationData && _.has(consolidationData, 'user_balance')"
          >
            <div class="admin-edit" @click="editTranslate(['consolidation_UserBalance',])"></div>
            <b>{{ $t('consolidation_UserBalance.localization_value.value') }}: ${{ consolidationData.user_balance }}</b>
          </div>
          <br>

          <div class="statistic-popup__price"
               v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
            <div class="admin-edit" @click="editTranslate(['dashboard_amountToPay',])"></div>
            <b>{{ $t('dashboard_amountToPay.localization_value.value') }}: ${{ consolidationData.total_amount }}</b>
          </div>
        </template>

        <div class="statistic-popup__price mb-2"
             v-if="payData && _.has(payData, 'orderAmount') && payData.orderAmount"
             v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
          <div class="admin-edit" @click="editTranslate(['dashboard_orderAmount',])"></div>
          <b>{{ $t('dashboard_orderAmount.localization_value.value') }}: ${{ payData.orderAmount }}</b>
        </div>
        <div class="statistic-popup__price mb-2"
             v-if="payData && _.has(payData, 'paySystemCommission') && payData.paySystemCommission"
             v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
          <div class="admin-edit" @click="editTranslate(['dashboard_paySystemCommission',])"></div>
          <b>{{ $t('dashboard_paySystemCommission.localization_value.value') }}: ${{ payData.paySystemCommission }}</b>
        </div>
        <div class="statistic-popup__price mb-2"
             v-if="payData && _.has(payData, 'userBalance') && payData.userBalance"
             v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
          <div class="admin-edit" @click="editTranslate(['dashboard_userBalance',])"></div>
          <b>{{ $t('dashboard_userBalance.localization_value.value') }}: ${{ payData.userBalance }}</b>
        </div>




        <div class="statistic-popup__price"
             v-if="!consolidationType"
             v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
          <div class="admin-edit" @click="editTranslate(['dashboard_amountToPay',])"></div>
          <b>{{ $t('dashboard_amountToPay.localization_value.value') }}: ${{ amount }}</b>
        </div>

        <div class="block-table">
          <div class="section-label"
               v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
            <div class="admin-edit" @click="editTranslate(['dashboard_cardDetails',])"></div>
            {{ $t('dashboard_cardDetails.localization_value.value') }}
          </div>


          <div class="block-table__row">

            <div class="block-table__col mb-3"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['dashboard_card',])"></div>
              <div class="default-input-wrap" v-bind:class="{'ui-no-valid' : Payment.validation.card}">
                <div id="card-number" class="default-input-wrap-custom default-input" v-bind:class="{'braintree-hosted-fields-text': Payment.validationTxt.card}"></div>
                <label class="default-input-wrap__label" for="card-number">
                  {{ $t('dashboard_card.localization_value.value') }}
                </label>
              </div>
            </div>

            <div class="block-table__col block-table__col--50 mb-3"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['dashboard_ExpirationDate',])"></div>
              <div class="default-input-wrap" v-bind:class="{'ui-no-valid' : Payment.validation.month}">
                <div id="expiration-date" class="default-input-wrap-custom default-input" v-bind:class="{'braintree-hosted-fields-text': Payment.validationTxt.month}"></div>
                <label class="default-input-wrap__label" for="expiration-date">
                  {{ $t('dashboard_ExpirationDate.localization_value.value') }}
                </label>
              </div>
            </div>
            <div class="block-table__col block-table__col--50 mb-3"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['common_CVV',])"></div>
              <div class="default-input-wrap" v-bind:class="{'ui-no-valid' : Payment.validation.cardCode}">
                <div id="cvv" class="default-input-wrap-custom default-input" v-bind:class="{'braintree-hosted-fields-text': Payment.validationTxt.cardCode}"></div>
                <label class="default-input-wrap__label" for="cvv">
                  {{ $t('common_CVV.localization_value.value') }}
                </label>
              </div>
            </div>
          </div>

          <div class="section-label"
               v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
            <div class="admin-edit" @click="editTranslate(['common_buildingAddress',])"></div>
            {{ $t('common_buildingAddress.localization_value.value') }}
          </div>

          <div class="block-table__row">

            <div class="block-table__col block-table__col--50"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['common_name',])"></div>
              <DefaultInput
                  :label="$t('common_name.localization_value.value')"
                  v-bind:class="{'ui-no-valid': Payment.validation.firstName}"
                  :error="Payment.validation.firstName"
                  :errorTxt="$t(`${Payment.validationTranslate.firstName}.localization_value.value`)"
                  :type="'text'"
                  :autocomplete="'family-name'"
                  :name="'family-name'"
                  v-model="Payment.data.firstName"
              />
            </div>
            <div class="block-table__col block-table__col--50"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['common_surName',])"></div>
              <DefaultInput
                  :label="$t('common_surName.localization_value.value')"
                  v-bind:class="{'ui-no-valid': Payment.validation.lastName}"
                  :error="Payment.validation.lastName"
                  :errorTxt="$t(`${Payment.validationTranslate.lastName}.localization_value.value`)"
                  :type="'text'"
                  :name="'name'"
                  :autocomplete="'additional-name'"
                  v-model="Payment.data.lastName"
              />
            </div>
          </div>
          <div class="block-table__row">
            <div class="block-table__col block-table__col--50"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['common_phone',])"></div>
              <DefaultInput
                  class="type-number"
                  :label="$t('common_phone.localization_value.value')"
                  v-bind:class="{'ui-no-valid': Payment.validation.phone}"
                  :error="Payment.validation.phone"
                  :errorTxt="$t(`${Payment.validationTranslate.phone}.localization_value.value`)"
                  :type="'text'"
                  :autocomplete="'tel'"
                  :name="'phone'"
                  :value="Payment.data.phone"
                  @blur="changePhone"
              />
<!--                  v-model="Payment.data.phone"-->
            </div>
            <div class="block-table__col block-table__col--50"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['common_country',])"></div>
              <DefaultSelect
                  v-bind:class="{'ui-no-valid': Payment.validation.selectedCountry}"
                  :error="Payment.validation.selectedCountry"
                  :errorTxt="$t(`${Payment.validationTranslate.selectedCountry}.localization_value.value`)"
                  :options="options"
                  @change="changeCountry"
                  :selected="Payment.data.selectedCountry"
                  :label="$t('common_country.localization_value.value')"
                  :optionsLabel="'label'"
              />
            </div>
          </div>
          <div class="block-table__row">
            <div class="block-table__col block-table__col--50"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['common_street',])"></div>
              <DefaultInput
                  :label="$t('common_street.localization_value.value')"
                  v-bind:class="{'ui-no-valid': Payment.validation.street}"
                  :error="Payment.validation.street"
                  :errorTxt="$t(`${Payment.validationTranslate.street}.localization_value.value`)"
                  :type="'text'"
                  :autocomplete="'street-address'"
                  :name="'street'"
                  v-model="Payment.data.street"
              />
            </div>
            <div class="block-table__col block-table__col--50"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['common_city',])"></div>
              <DefaultInput
                  :label="$t('common_city.localization_value.value')"
                  v-bind:class="{'ui-no-valid': Payment.validation.city}"
                  :error="Payment.validation.city"
                  :errorTxt="$t(`${Payment.validationTranslate.city}.localization_value.value`)"
                  :type="'text'"
                  :name="'city'"
                  :autocomplete="'address-level2'"
                  v-model="Payment.data.city"
              />
            </div>
          </div>
          <div class="block-table__row">
            <div class="block-table__col block-table__col--50"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['common_state',])"></div>
              <DefaultSelect
                  v-if="Payment.data.selectedCountry && Payment.data.selectedCountry.id === USA_COUNTRY_ID && regions.length > 0"
                  :options="regions"
                  :label="$t('common_state.localization_value.value')"
                  v-bind:class="{'ui-no-valid': Payment.validation.state}"
                  :errorTxt="$t(`${Payment.validationTranslate.state}.localization_value.value`)"
                  :error="Payment.validation.state"
                  :optionsLabel="'code'"
                  :selected="Payment.data.state.code"
                  @change="val => {changeRegion(val)}"
              />
              <DefaultInput
                  v-else
                  :label="$t('common_state.localization_value.value')"
                  v-bind:class="{'ui-no-valid': Payment.validation.state}"
                  :error="Payment.validation.state"
                  :errorTxt="$t(`${Payment.validationTranslate.state}.localization_value.value`)"
                  :type="'text'"
                  :name="'region'"
                  :autocomplete="'address-level1'"
                  v-model="Payment.data.state"
              />
            </div>
            <div class="block-table__col block-table__col--25"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['common_zipCode',])"></div>
              <DefaultInput
                  :label="$t('common_zipCode.localization_value.value')"
                  v-bind:class="{'ui-no-valid': Payment.validation.zipCode}"
                  :error="Payment.validation.zipCode"
                  :errorTxt="$t(`${Payment.validationTranslate.zipCode}.localization_value.value`)"
                  :type="'text'"
                  :name="'zip'"
                  :autocomplete="'postal-code'"
                  v-model="Payment.data.zipCode"
              />
            </div>
          </div>

          <div class="ui-no-valid-card" v-if="Payment.validation.error">
            {{ Payment.validationTxt.error }}
          </div>
        </div>

      </form>
<!--      <script src="https://js.braintreegateway.com/web/dropin/1.34.0/js/dropin.min.js"></script>-->
    </template>

    <template slot="footer">
      <div class="buy-label__btn d-flex align-items-center mt-5"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['common_SaveInDrafts','common_cancel', 'common_payByCard', 'common_payByGooglePay', 'common_payByApplePay'])"></div>

<!--        <span-->
<!--            v-if="canBeClosedByUser !== false"-->
<!--            @click="$emit('close')"-->
<!--            class="site-link site-link&#45;&#45;alt mr-4 close-link"-->
<!--        >-->
<!--          <template v-if="changeCloseToSaveBtn">-->
<!--            {{$t('common_SaveInDrafts.localization_value.value')}}-->
<!--          </template>-->
<!--          <template v-else>-->
<!--					  {{ $t('common_cancel.localization_value.value') }}-->
<!--          </template>-->
<!--				</span>-->
        <MainButton
            v-if="canBeClosedByUser !== false"
            class="wfc secondary"
            :value="changeCloseToSaveBtn ? $t('common_SaveInDrafts.localization_value.value') : $t('common_cancel.localization_value.value')"
            @click.native="$emit('close')"
            v-bind:class="{'disabled-btn' : $store.getters.getBrainTreeAPIBtn, 'd-none': loading}"
        />

        <MainButton
            id="submit-button"
            :value="$t('common_payByCard.localization_value.value')"
            class="buy-label__btn-i wfc "
            v-bind:class="{'disabled-btn' : $store.getters.getBrainTreeAPIBtn}"
        />

        <!-- html fragment -->
        <div
            v-bind:class="{'d-none': loading}"
            id="google-pay-button" style="width: 150px; height: 43px; margin-left: 15px;"></div>



<!--        <MainButton-->
<!--            id="google-pay-button"-->
<!--            :value="$t('common_payByGooglePay.localization_value.value')"-->
<!--            class="buy-label__btn-i wfc ml-3 secondary"-->
<!--            :ico="true"-->
<!--            v-bind:class="{'disabled-btn' : $store.getters.getBrainTreeAPIBtn}"-->
<!--        >-->
<!--          <template slot="ico">-->
<!--            <svg x="39" y="13" width="41" height="17">-->
<!--              <g fill="none" fill-rule="evenodd">-->
<!--&lt;!&ndash;                <path d="M19.526 2.635v4.083h2.518c.6 0 1.096-.202 1.488-.605.403-.402.605-.882.605-1.437 0-.544-.202-1.018-.605-1.422-.392-.413-.888-.62-1.488-.62h-2.518zm0 5.52v4.736h-1.504V1.198h3.99c1.013 0 1.873.337 2.582 1.012.72.675 1.08 1.497 1.08 2.466 0 .991-.36 1.819-1.08 2.482-.697.665-1.559.996-2.583.996h-2.485v.001zm7.668 2.287c0 .392.166.718.499.98.332.26.722.391 1.168.391.633 0 1.196-.234 1.692-.701.497-.469.744-1.019.744-1.65-.469-.37-1.123-.555-1.962-.555-.61 0-1.12.148-1.528.442-.409.294-.613.657-.613 1.093m1.946-5.815c1.112 0 1.989.297 2.633.89.642.594.964 1.408.964 2.442v4.932h-1.439v-1.11h-.065c-.622.914-1.45 1.372-2.486 1.372-.882 0-1.621-.262-2.215-.784-.594-.523-.891-1.176-.891-1.96 0-.828.313-1.486.94-1.976s1.463-.735 2.51-.735c.892 0 1.629.163 2.206.49v-.344c0-.522-.207-.966-.621-1.33a2.132 2.132 0 0 0-1.455-.547c-.84 0-1.504.353-1.995 1.062l-1.324-.834c.73-1.045 1.81-1.568 3.238-1.568m11.853.262l-5.02 11.53H34.42l1.864-4.034-3.302-7.496h1.635l2.387 5.749h.032l2.322-5.75z" fill="#FFF"></path>&ndash;&gt;-->
<!--                <path d="M13.448 7.134c0-.473-.04-.93-.116-1.366H6.988v2.588h3.634a3.11 3.11 0 0 1-1.344 2.042v1.68h2.169c1.27-1.17 2.001-2.9 2.001-4.944" fill="#4285F4"></path>-->
<!--                <path d="M6.988 13.7c1.816 0 3.344-.595 4.459-1.621l-2.169-1.681c-.603.406-1.38.643-2.29.643-1.754 0-3.244-1.182-3.776-2.774H.978v1.731a6.728 6.728 0 0 0 6.01 3.703" fill="#34A853"></path>-->
<!--                <path d="M3.212 8.267a4.034 4.034 0 0 1 0-2.572V3.964H.978A6.678 6.678 0 0 0 .261 6.98c0 1.085.26 2.11.717 3.017l2.234-1.731z" fill="#FABB05"></path>-->
<!--                <path d="M6.988 2.921c.992 0 1.88.34 2.58 1.008v.001l1.92-1.918C10.324.928 8.804.262 6.989.262a6.728 6.728 0 0 0-6.01 3.702l2.234 1.731c.532-1.592 2.022-2.774 3.776-2.774" fill="#E94235"></path>-->
<!--              </g>-->
<!--            </svg>-->
<!--          </template>-->
<!--        </MainButton>-->

<!--        <MainButton-->
<!--            v-show="canApplePay"-->
<!--            id="apple-pay-button"-->
<!--            :value="$t('common_payByApplePay.localization_value.value')"-->
<!--            class="buy-label__btn-i wfc ml-3"-->
<!--            v-bind:class="{'disabled-btn' : $store.getters.getBrainTreeAPIBtn}"-->
<!--        />-->
        <div class="apple-pay-button buy-label__btn-i wfc ml-3"
             v-show="canApplePay"
             id="apple-pay-button"
             :value="$t('common_payByApplePay.localization_value.value')"
             v-bind:class="{'disabled-btn' : $store.getters.getBrainTreeAPIBtn}"
        >
          <svg width="150" height="43" viewBox="0 0 150 43" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="150" height="43" rx="4" fill="black"/>
            <path d="M59.2479 15.793C57.9114 15.793 56.8333 16.6016 56.137 16.6016C55.407 16.6016 54.43 15.8379 53.2732 15.8379C51.0721 15.8379 48.8372 17.6685 48.8372 21.0938C48.8372 23.2388 49.6683 25.4961 50.6902 26.9673C51.555 28.1914 52.3299 29.2021 53.4305 29.2021C54.5198 29.2021 55.0027 28.4834 56.3616 28.4834C57.7317 28.4834 58.0462 29.1797 59.2479 29.1797C60.4495 29.1797 61.2469 28.0903 61.9993 27.0122C62.8304 25.7656 63.1898 24.5527 63.201 24.4966C63.1336 24.4741 60.8426 23.542 60.8426 20.9141C60.8426 18.6455 62.6395 17.6348 62.7405 17.5562C61.5613 15.8379 59.7532 15.793 59.2479 15.793ZM58.6302 14.3442C59.1692 13.6816 59.5511 12.7832 59.5511 11.8735C59.5511 11.75 59.5399 11.6265 59.5174 11.5254C58.6414 11.5591 57.5633 12.1094 56.9232 12.8618C56.429 13.4346 55.9573 14.3442 55.9573 15.2539C55.9573 15.3887 55.9798 15.5347 55.991 15.5796C56.0472 15.5908 56.137 15.6021 56.2269 15.6021C57.0242 15.6021 58.035 15.063 58.6302 14.3442ZM67.6155 12.7944V29H70.513V23.688H74.0281C77.3074 23.688 79.5984 21.4868 79.5984 18.2749C79.5984 15.0068 77.386 12.7944 74.1516 12.7944H67.6155ZM70.513 15.2202H73.388C75.4768 15.2202 76.656 16.2871 76.656 18.2749C76.656 20.2065 75.4431 21.2847 73.3767 21.2847H70.513V15.2202ZM85.0349 27.0122C83.7995 27.0122 82.9123 26.3945 82.9123 25.3613C82.9123 24.3618 83.6423 23.8003 85.2033 23.6992L87.9773 23.5195V24.4966C87.9773 25.9229 86.7195 27.0122 85.0349 27.0122ZM84.2151 29.2021C85.821 29.2021 87.1687 28.5059 87.8537 27.3154H88.0447V29H90.7287V20.6108C90.7287 18.0054 88.9543 16.4668 85.7986 16.4668C82.8786 16.4668 80.8459 17.8481 80.6213 20.0156H83.2492C83.5075 19.1846 84.3835 18.7354 85.6638 18.7354C87.1687 18.7354 87.9773 19.4092 87.9773 20.6108V21.644L84.8103 21.835C81.823 22.0146 80.1496 23.2949 80.1496 25.5186C80.1496 27.7646 81.8454 29.2021 84.2151 29.2021ZM93.8293 33.4585C96.5808 33.4585 97.8947 32.4478 98.9392 29.3931L103.375 16.7139H100.433L97.569 26.3047H97.3781L94.5031 16.7139H91.4484L95.8395 29.0562L95.6936 29.5952C95.3342 30.7295 94.6716 31.1787 93.4924 31.1787C93.3015 31.1787 92.8859 31.1675 92.7287 31.1338V33.4136C92.9084 33.4473 93.6608 33.4585 93.8293 33.4585Z" fill="white"/>
            <rect width="150" height="43" rx="4" stroke="black"/>
          </svg>
        </div>

        <div class="pt-2 pb-3 dots" v-if="loading">
          <DotsShadowPreloader/>
        </div>
      </div>
    </template>

  </modal>
</template>

<script>

import Modal from "../../../commonModals/Modal";
import MainButton from "@/components/UI/buttons/MainButton/MainButton";
import DotsShadowPreloader from "@/components/coreComponents/preloaders/DotsShadowPreloader/DotsShadowPreloader";
import DefaultInput from "@/components/UI/inputs/DefaultInput/DefaultInput";
import {Payment} from "@/components/globalModels/Payment";
import DefaultSelect from "@/components/UI/selectiones/DefaultSelect/DefaultSelect";
import {USA_COUNTRY_ID} from "@/staticData/staticVariables";
import {filterCountriesUaBel, filterCountryPoland} from "@/services/filterCountries";

export default {
  name: "BraintreePaymentPopup",
  components: {
    DefaultSelect,
    DefaultInput,
    DotsShadowPreloader,
    MainButton,
    Modal,
  },

  props: {
    amount: [Number, String],

    invoicePayId: {
      type: [Number, String],
      default: null,
    },

    authorizePayData: {},

    changeCloseToSaveBtn: {
      type: Boolean,
      default: false
    },

    canBeClosedByUser: {
      type: Boolean,
      default: true,
    },

    titleText: {
      type: String,
      default: '',
    },

    consolidationType: {
      type: Boolean,
      default: false,
    },

    consolidationData: Object,
    payData: Object,
  },

  data() {
    return {
      loading: true,
      token: false,

      deviceData: null,

      Payment: new Payment(),

      options: [],
      regions: [],

      canApplePay: false,

      USA_COUNTRY_ID: USA_COUNTRY_ID,
    }
  },

  mounted() {

    this.$store.dispatch('fetchCountries').then(() => {
      let countries = this._.toArray(this.$store.getters.getCountries);
      let filteredCountries = null

      if(this.isUserHasEasyOrder) {
        filteredCountries = filterCountryPoland(countries)
      } else {
        filteredCountries = filterCountriesUaBel(countries)
      }

      this.options = filteredCountries.countries;
    })

    this.$store.dispatch('getBrainTreeToken').then(response => {
      switch (this.getResponseStatus(response)) {
          /**
           * Success
           */
        case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {
          this.token = response.data.token
          this.initiateCall()
          break
        }
          /**
           * Validation Error
           */
        case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
          let errors = response.response.data.errors;
          this.notifyErrorHelper(errors)
          break
        }
          /**
           * Undefined Error
           */
        default: {
          this.openNotify('error', 'common_notificationUndefinedError')
        }
      }
    })

  },

  methods: {

    changeCountry(val) {
      if (val === '') {
        this.Payment.setSelectedCountry('')
      } else {
        this.Payment.setSelectedCountry(val)
        this.Payment.setState('')
        if (val.id === USA_COUNTRY_ID && this.regions.length === 0) {
          this.$store.dispatch('getRegionsByCountry', val.id).then(() => {
            this.regions = this._.toArray(this.$store.getters.getRegions)
          }).catch(error => this.createErrorLog(error));
        }
      }
    },

    changePhone(val) {
      this.Payment.setPhone(val.replace(/[^0-9.]/g, ''))
    },

    changeRegion(val) {
      this.Payment.setState(val)
    },

    payByCardFunction(clientInstance, button) {
      window.braintree.hostedFields.create({
            client: clientInstance,
            styles: {
              'input': {
                'font-size': '14px',
                // 'font-family': 'roboto',
                // 'font-weight': 'lighter',
                'color': '#232323'
              },
              ':focus': {
                'color': '#232323'
              },
              '.valid': {
                'color': '#232323'
              },
              '.invalid': {
                'color': '#232323'
              }
            },
            fields: {
              number: {
                selector: '#card-number',
                placeholder: ''
              },
              cvv: {
                selector: '#cvv',
                placeholder: ''
              },
              expirationDate: {
                selector: '#expiration-date',
                placeholder: ''
              },
              // postalCode: {
              //   selector: '#postal-code',
              //   placeholder: '11111'
              // }
            }
          },
          (err, hostedFieldsInstance) => {

            this.loading = false

            if (err) {
              console.error(err);
              this.openNotify('error', 'common_notificationUndefinedError')
              return
            }

            hostedFieldsInstance.on('blur', (event) => {
              this.Payment.validationTxt.card = !event.fields.number.isEmpty
              this.Payment.validationTxt.month = !event.fields.expirationDate.isEmpty
              this.Payment.validationTxt.cardCode = !event.fields.cvv.isEmpty

              if(event.emittedBy === 'number') this.Payment.validation.card = !event.fields.number.isValid
              if(event.emittedBy === 'expirationDate') this.Payment.validation.month = !event.fields.expirationDate.isValid
              if(event.emittedBy === 'cvv') this.Payment.validation.cardCode = !event.fields.cvv.isValid
            })

            button.addEventListener('click', () => {

              console.log(43543);
              console.log(this.Payment.firstValidation({card: false, month: false, year: false, cardCode: false,}));
              if(!this.Payment.firstValidation({card: false, month: false, year: false, cardCode: false,}))
                return

              hostedFieldsInstance.tokenize((err, payload) => {
                if (err) {
                  console.error(err);
                  this.openNotify('error', 'common_notificationUndefinedError')
                  return
                }

                if(this.invoicePayId && Number(this.invoicePayId !== -1)) {
                  this.sendSuccessRequestWithInvoice(payload)
                } else {
                  this.sendSuccessRequest(payload)
                }
              })
            })
          })
    },

    async payByGooglePayFunction(clientInstance, paymentsClient, paymentButtonGoogle) {

      let googleMerchantId = 'your-merchant-id-from-google'

      await this.$store.dispatch('getBrainTreeGoogleMerchantId').then(response => {
        googleMerchantId = this.getRespData(response)?.merchantId
      })

      // console.log(googleMerchantId);

      window.braintree.googlePayment.create({
            client: clientInstance,
            googlePayVersion: 2,
            googleMerchantId: googleMerchantId,
          },
          (err, googlePaymentInstance) => {

            if (err) {
              this.openNotify('error', 'common_notificationUndefinedError')
              return
            }

            paymentsClient.isReadyToPay({
              apiVersion: 2,
              apiVersionMinor: 0,
              allowedPaymentMethods: googlePaymentInstance.createPaymentDataRequest().allowedPaymentMethods,
              existingPaymentMethodRequired: true // Optional
            }).then(response => {

              if (response.result) {

                // javascript fragment
                const container = document.getElementById('google-pay-button');
                const googlePayButton = paymentsClient.createButton({
                  buttonColor: 'black',
                  buttonType: 'plain',
                  buttonSizeMode: 'fill',
                  onClick: () => {},
                  allowedPaymentMethods: [] // use the same payment methods as for the loadPaymentData() API call
                });
                container.appendChild(googlePayButton);

                paymentButtonGoogle.addEventListener('click', (event) => {
                  let paymentDataRequest

                  event.preventDefault()

                  paymentDataRequest = googlePaymentInstance.createPaymentDataRequest({
                    transactionInfo: {
                      currencyCode: 'USD',
                      totalPriceStatus: 'FINAL',
                      totalPrice: String(this.amount)
                    }
                  })

                  let cardPaymentMethod = paymentDataRequest.allowedPaymentMethods[0]
                  cardPaymentMethod.parameters.billingAddressRequired = true
                  cardPaymentMethod.parameters.billingAddressParameters = {
                    format: 'FULL',
                    phoneNumberRequired: true
                  }

                  paymentsClient.loadPaymentData(paymentDataRequest).then((paymentData) => {
                    if(paymentData?.paymentMethodData?.info?.billingAddress) {

                      let billingAddress = paymentData?.paymentMethodData?.info?.billingAddress

                      this.Payment.data.firstName = billingAddress?.name.split(' ')[0]
                      this.Payment.data.lastName = billingAddress?.name.split(' ')[1]
                      this.Payment.data.phone = billingAddress?.phoneNumber.replaceAll(' ', '').replace('+', '')
                      this.Payment.data.city = paymentData?.paymentMethodData?.info?.billingAddress?.locality
                      this.Payment.data.zipCode = billingAddress?.postalCode
                      this.Payment.data.street = billingAddress?.address1

                      if(billingAddress?.administrativeArea) {
                        this.Payment.data.state = billingAddress?.administrativeArea
                      }

                      this.Payment.data.selectedCountry = this._.find(this.options, {code_iso_2: billingAddress?.countryCode})
                    }

                    return googlePaymentInstance.parseResponse(paymentData)
                  }).then(payload => {
                    // send result.nonce to your server

                    if(this.invoicePayId && Number(this.invoicePayId !== -1)) {
                      this.sendSuccessRequestWithInvoice(payload, true)
                    } else {
                      this.sendSuccessRequest(payload, true)
                    }

                  }).catch(err => {
                    console.log(err)
                    this.openNotify('error', 'common_notificationUndefinedError')
                    // handle err
                  })
                })
              }

            })


          })
    },

    payByApplePayFunction(clientInstance, paymentButtonApple) {
      if (window.ApplePaySession && window.ApplePaySession.supportsVersion(3) && window.ApplePaySession.canMakePayments()) {

        this.canApplePay = true

        window.braintree.applePay.create({
          client: clientInstance
        },
          (applePayErr, applePayInstance) => {
            if (applePayErr) {
              console.error('Error creating applePayInstance:', applePayErr)
              return
            }
            // Set up your Apple Pay button here

            paymentButtonApple.addEventListener('click', (event) => {
              event.preventDefault()

              let paymentRequest = applePayInstance.createPaymentRequest({
                total: {
                  label: 'Skladusa',
                  amount: this.amount
                },

                // We recommend collecting billing address information, at minimum
                // billing postal code, and passing that billing postal code with
                // all Apple Pay transactions as a best practice.
                requiredBillingContactFields: ["postalAddress"]
              });
              console.log(paymentRequest.countryCode)
              console.log(paymentRequest.currencyCode)
              console.log(paymentRequest.merchantCapabilities)
              console.log(paymentRequest.supportedNetworks)


              let applePaySession = window.ApplePaySession
              let session = new applePaySession(3, paymentRequest)

              session.onvalidatemerchant = (event) => {
                let merchant = 'merchant.dev.skladusa'
                let domainName = 'skladusa.dev'

                if(window.location.hostname.indexOf('system') === 0) {
                  merchant = 'merchant.dev.skladusa.prodkeys'
                  domainName = 'system.skladusa.com'
                }

                applePayInstance.performValidation({
                  validationURL: event.validationURL,
                  displayName: 'Skladusa',
                  merchantIdentifier: merchant,
                  domainName: domainName,
                }, function (err, merchantSession) {
                  if (err) {
                    // You should show an error to the user, e.g. 'Apple Pay failed to load.'
                    console.log(err);
                    this.openNotify('error', 'common_notificationUndefinedError')
                    return
                  }
                  console.log(merchantSession);
                  session.completeMerchantValidation(merchantSession);
                })
              }

              session.onpaymentauthorized = (event) => {
                console.log('Your shipping address is:', event.payment.shippingContact)

                applePayInstance.tokenize({
                  token: event.payment.token
                }, (tokenizeErr, payload) => {
                  if (tokenizeErr) {
                    console.error('Error tokenizing Apple Pay:', tokenizeErr)
                    session.completePayment(window.ApplePaySession.STATUS_FAILURE)
                    return
                  }

                  // After you have transacted with the payload.nonce,
                  // call `completePayment` to dismiss the Apple Pay sheet.
                  session.completePayment(window.ApplePaySession.STATUS_SUCCESS)

                  let billingAddress = event.payment.billingContact

                  this.Payment.data.firstName = billingAddress?.givenName
                  this.Payment.data.lastName = billingAddress?.familyName
                  this.Payment.data.phone = billingAddress?.phoneNumber ? billingAddress?.phoneNumber.replaceAll(' ', '').replace('+', '').replace('(', '').replace(')', '') : '9999999999'
                  this.Payment.data.city = billingAddress?.locality
                  this.Payment.data.zipCode = billingAddress?.postalCode
                  this.Payment.data.street = billingAddress?.addressLines.join(', ')

                  if(billingAddress?.administrativeArea) {
                    this.Payment.data.state = billingAddress?.administrativeArea
                  }

                  this.Payment.data.selectedCountry = this._.find(this.options, {code_iso_2: billingAddress?.countryCode})

                  if(this.invoicePayId && Number(this.invoicePayId !== -1)) {
                    this.sendSuccessRequestWithInvoice(payload, true)
                  } else {
                    this.sendSuccessRequest(payload, true)
                  }
                })
              }

              session.begin()

            })

          })

      } else {
        console.error('This device does not support Apple Pay');
        console.error('This device is not capable of making Apple Pay payments');
      }
    },

    getDeviceDataFunction(clientInstance) {
      window.braintree.dataCollector.create({
            client: clientInstance
          },
          (err, dataCollectorInstance) => {
            if (err) {
              // Handle error in creation of data collector
              this.openNotify('error', 'common_notificationUndefinedError')
              return;
            }
            // At this point, you should access the dataCollectorInstance.deviceData value and provide it
            // to your server, e.g. by injecting it into your form as a hidden input.
            let deviceData = dataCollectorInstance.deviceData;

            this.deviceData = deviceData
          })
    },

    initScript() {

      let button = document.querySelector('#submit-button')

      let paymentButtonGoogle = document.querySelector('#google-pay-button')

      let paymentButtonApple = document.querySelector('#apple-pay-button')

      let paymentsClient = new window.google.payments.api.PaymentsClient({
        environment: 'PRODUCTION' // or 'TEST'
      })

      window.braintree.client.create({
        authorization: this.token,
        // container: '#dropin-container'
      }, (createErr, clientInstance) => {

        if(createErr) {
          console.log(createErr)
        }

        this.payByCardFunction(clientInstance, button)

        this.payByGooglePayFunction(clientInstance, paymentsClient, paymentButtonGoogle)

        this.payByApplePayFunction(clientInstance, paymentButtonApple)

        this.getDeviceDataFunction(clientInstance)

      })
    },

    sendSuccessRequest(payload, deviceDataRequired = false) {
      let data = {
        from_dashboard: 1,
        amount: this.amount,
        payment_method_nonce: payload.nonce,

        "contact": {
          "firstName": this.Payment.data.firstName,
          "lastName": this.Payment.data.lastName,
          "phone": this.Payment.data.phone.replaceAll('+', ''),
          "city": this.Payment.data.city,
          "zip": this.Payment.data.zipCode,
          "email": "ssdsd@sadsad.sad2",
          "address": this.Payment.data.street,
          "state": this.Payment.data.state?.id ? this.Payment.data.state?.code : this.Payment.data.state,
          "country": this.Payment.data.selectedCountry?.label,
        },
      }

      if(deviceDataRequired) {
        data['device-data'] = this.deviceData
      }

      this.$store.dispatch('newBrainTree', data).then(response => {
        switch (this.getResponseStatus(response)) {
            /**
             * Success
             */
          case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {
            // this.openNotify('success', 'common_notificationRecordCreated')
            this.$emit('submitForm')
            this.$emit('close')
            break
          }
            /**
             * Validation Error
             */
          case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
            let errors = response.response.data.errors;
            this.notifyErrorHelper(errors)
            break
          }
            /**
             * Undefined Error
             */
          default: {
            this.openNotify('error', 'common_notificationUndefinedError')
          }
        }
      })
    },

    sendSuccessRequestWithInvoice(payload, deviceDataRequired = false) {
      let data = {
        amount: this.amount,
        payment_method_nonce: payload.nonce,

        "contact": {
          "firstName": this.Payment.data.firstName,
          "lastName": this.Payment.data.lastName,
          "phone": this.Payment.data.phone.replaceAll('+', ''),
          "city": this.Payment.data.city,
          "zip": this.Payment.data.zipCode,
          "email": "ssdsd@sadsad.sad2",
          "address": this.Payment.data.street,
          "state": this.Payment.data.state?.id ? this.Payment.data.state?.code : this.Payment.data.state,
          "country": this.Payment.data.selectedCountry?.label,
        },

        "invoice_id": this.invoicePayId,
      }

      if(deviceDataRequired) {
        data['device-data'] = this.deviceData
      }

      this.$store.dispatch('newPaymentBrainTreeInvoice', data).then(response => {
        switch (this.getResponseStatus(response)) {
            /**
             * Success
             */
          case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {
            // this.openNotify('success', 'common_notificationRecordCreated')
            this.$emit('submitForm')
            this.$emit('close')
            break
          }
            /**
             * Validation Error
             */
          case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
            let errors = response.response.data.errors;
            this.notifyErrorHelper(errors)
            break
          }
            /**
             * Undefined Error
             */
          default: {
            this.openNotify('error', 'common_notificationUndefinedError')
          }
        }
      })
    },

    initialize(i, t) {
      let e;
      i.getElementById(t) ? this.initScript() : (
          (e = i.createElement("script")).id = t,
              e.async = !0, e.src = "https://js.braintreegateway.com/web/dropin/1.34.0/js/dropin.min.js",
              e.onload = this.initialize2, i.head.appendChild(e))
    },

    initialize2() {
      let e;
      document.getElementById('brainTree1') ? this.initialize3() : (
          (e = document.createElement("script")).id = 'brainTree1',
              e.async = !0, e.src = "https://js.braintreegateway.com/web/3.91.0/js/hosted-fields.min.js",
              e.onload = this.initialize3, document.head.appendChild(e))
    },

    initialize3() {
      let e;
      document.getElementById('brainTree2') ? this.initializeAppleGoogle() : (
          (e = document.createElement("script")).id = 'brainTree2',
              e.async = !0, e.src = "https://js.braintreegateway.com/web/3.91.0/js/client.min.js",
              e.onload = this.initializeAppleGoogle, document.head.appendChild(e))
    },

    initializeAppleGoogle() {
      let e;
      document.getElementById('brainTreeAppleGoogle') ? this.initializeGooglePay() : (
          (e = document.createElement("script")).id = 'brainTreeAppleGoogle',
              e.async = !0, e.src = "https://js.braintreegateway.com/web/3.91.0/js/data-collector.min.js",
              e.onload = this.initializeGooglePay, document.head.appendChild(e))
    },

    initializeGooglePay() {
      let e;
      document.getElementById('brainTreeGooglePay') ? this.initializeGooglePay2() : (
          (e = document.createElement("script")).id = 'brainTreeGooglePay',
              e.async = !0, e.src = "https://pay.google.com/gp/p/js/pay.js",
              e.onload = this.initializeGooglePay2, document.head.appendChild(e))
    },

    initializeGooglePay2() {
      let e;
      document.getElementById('brainTreeGooglePay2') ? this.initializeApplePay() : (
          (e = document.createElement("script")).id = 'brainTreeGooglePay2',
              e.async = !0, e.src = "https://js.braintreegateway.com/web/3.91.0/js/google-payment.min.js",
              e.onload = this.initializeApplePay, document.head.appendChild(e))
    },

    initializeApplePay() {
      let e;
      document.getElementById('initializeApplePay') ? this.initScript() : (
          (e = document.createElement("script")).id = 'initializeApplePay',
              e.async = !0, e.src = "https://js.braintreegateway.com/web/3.91.0/js/apple-pay.min.js",
              e.onload = this.initScript, document.head.appendChild(e))
    },

    initiateCall() {
      this.initialize(document, 'brainTree')
      // this.initialize2(document, 'brainTree')
    },
  },

}
</script>

<style scoped>
  .loading .close-link,
  .loading >>> .modal-component__close,
  .loading .buy-label__btn-i {
    display: none;
  }

  .loading >>> .modal-component__content,
  .loading >>> .modal-component__inner {
    background: transparent;
  }

  .loading >>> .modal-component__body {
    height: 300px;
  }

  .loading >>> .dots{
    margin-left: -15px;
    position: absolute;
    left: 50%;
  }

  .apple-pay-button {
    /*position: relative;*/
    /*top: 2px;*/
    height: 43px;
    background: black;
    display: flex;
    justify-content: center;
    border-radius: 4px;
    cursor: pointer;
  }

  .apple-pay-button:hover {
    opacity: 0.8;
  }

  #google-pay-button >>> .main-button__ico{
    max-width: 17px;
    padding-top: 5px;
  }

  .buy-label__btn {
    flex-wrap: wrap;
  }
  .buy-label__btn > * {
    margin-bottom: 15px;
    margin-right: 15px !important;
    margin-left: 0 !important;
  }
</style>

<style lang="scss" scoped>
/*--------------------
SHARED VARIABLES
--------------------*/
$red: #E91E63;
$blue: #3F51B5;
$grey: #EAE8E9;
$grey2: #f3f3f3;
$white: #FFF;

/*--------------------
GENERAL
--------------------*/

*,
*:before,
*:after {
  box-sizing: inherit;
}

html {
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
}

body {
  background: #f2f2f2;
  font-family: 'Roboto', verdana, sans-serif;
  height: 100%;
}

h1 {
  font-size: 1.5em;
  font-weight: 100;
}

#cardForm {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}


/*--------------------
PANEL FORM
--------------------*/

.panel {
  background: $white;
  width: 80%;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .16), 0 0 2px 0 rgba(0, 0, 0, .12);
}

.panel__header {
  background: $blue;
  color: $white;
}

.panel__header,
.panel__footer {
  padding: 1em 2em;
}

.panel__footer {
  background: $grey2;
}

.panel__content {
  padding: 1em 2em;
  overflow: hidden;
}

.textfield--float-label {
  width: 50%;
  float: left;
  display: inline-block;
  padding-right: 5px;
}

.hosted-field--label {
  transform: translateY(0.4em);
  font-size: 1.125em;
  line-height: 32px;
  transition: all .15s ease-out;
  display: block;
  width: 100%;
  font-weight: 400;
  overflow: hidden;
  margin-bottom: 0.5em;
  &.label-float {
    text-overflow: ellipsis;
    color: #2196F3;
    transition: all .15s ease-out
  }
  &.filled {
    @extend .label-float;
    color: rgba(0, 0, 0, .54);
  }
  &.invalid {
    @extend .label-float;
    color: #F44336;
  }
}

span.icon {
  position: relative;
  top: 0.2em;
  margin-right: 0.2em;
}

//svg {
//  fill: #333;
//}

.hosted-field {
  height: 32px;
  margin-bottom: 1em;
  display: block;
  background-color: transparent;
  color: rgba(0, 0, 0, .87);
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, .26);
  outline: 0;
  width: 100%;
  font-size: 16px;
  padding: 0;
  box-shadow: none;
  border-radius: 0;
  position: relative;
}

.pay-button {
  background: #E91E63;
  color: #fff;
  margin: 0 auto;
  border: 0;
  border-radius: 3px;
  padding: 1em 3em;
  font-size: 1em;
  text-transform: uppercase;
  box-shadow: 0 0 2px rgba(0, 0, 0, .12), 0 2px 2px rgba(0, 0, 0, .2);
}


/*--------------------
BT HOSTED FIELDS SPECIFIC
--------------------*/

.braintree-hosted-fields-text + .default-input-wrap__label,
.braintree-hosted-fields-focused + .default-input-wrap__label{

  top: -5px;
  background: white;
  background: linear-gradient(0deg, #F8F4EE 0%, #FFFFFF 105.56%);
  padding: 0 2px;
  font-size: 10px;
  line-height: 12px;
}

.braintree-hosted-fields-invalid {
  border-bottom: 2px solid $red;
  transition: all 200ms ease;
}


/*---------------------
Media Queries
----------------------*/

@media (max-width: 500px) {
  .buy-label__btn {
    //flex-direction: row-reverse;
    justify-content: space-between;

    .main-button {
      width: 48% !important;
      margin-right: 0 !important;
      order: 2;

      &.secondary {
        order: 3;
      }
    }

    #google-pay-button,
    #apple-pay-button {
      width: 100% !important;
      margin-right: 0 !important;
    }

    #google-pay-button {
      order: 0;
    }
    #apple-pay-button {
      order: 1;
    }
  }
}

@media (max-width: 600px) {
  html {
    overflow: auto;
  }
  #cardForm {
    height: auto;
    margin: 2em;
    font-size: 13px;
  }
  .panel {
    width: 100%;
  }
  .textfield--float-label {
    width: 100%;
    float: none;
    display: inline-block;
  }
  .pay-button {
    width: 100%;
  }
}


.default-input-wrap-custom{
  font-size: 14px;
  line-height: 16px;
  width: 100%;
  padding-left: 16px;
  padding-right: 16px;
  height: 42px;
  background: #F8F4EE;
  border: 1px solid #BBAD9C;
  box-sizing: border-box;
  border-radius: 5px;
}

</style>